<div class="card">
  <div class="card-header p-2" routerLink="/adresse">
    <button class="btn btn-primary btn-sm btn-floating float-end m-0">
      <i class="fal fa-search" aria-hidden="true"></i>
    </button>
    <h4 class="card-title mb-0 mt-1">
      <a class="text-reset text-decoration-none" routerLink="/adresse">
        <i class="fal fa-address-card" aria-hidden="true"></i>
        Adresse
      </a>
    </h4>
  </div>
  @if (!data) {
    <div class="card-body b2-card pe-2"></div>
  }
  @if (data) {
    <div class="card-body b2-card pe-2" [routerLink]="['/adresse', data.id]">
      @if (data.adresse || data.plzOrt) {
        <button
          class="btn btn-primary btn-sm btn-floating float-end m-0"
          (click)="openMapLink(data); $event.stopPropagation()"
        >
          <i class="fal fa-map-marker" aria-hidden="true"></i>
        </button>
      }
      @if (data.vorname || data.name || data.adresse || data.plzOrt) {
        <a class="card-text hand d-block text-reset text-decoration-none">
          {{ data.vorname }}
          {{ data.name }}
          <br />
          {{ data.adresse }}
          <br />
          {{ data.plzOrt }}
        </a>
      }
    </div>
  }
</div>
